import { withProperties } from "../../../../utils";
import withReactiveFields from "../../helpers/reactivefields";
import { USES_CHARGE_POLLING } from "../../../../charge/flags";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";

import InitView from "./views/init";
import RedirectView from "../../common/redirect";

const METHOD = 'cryptocurrency';
const METHOD_NAME = 'BitPay';
const CHARGE_MODE = USES_CHARGE_POLLING;

const VIEWS = [ InitView ];

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the bank (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      const VIEW = (
        this.REDIRECT_URL && (RedirectView || (this.REDIRECT_URL = null))
      ) || InitView;
      
      VIEW && VIEW.activate.call(this);
    });

    getChargeFee();
  };
}

function getChargeData() {
  return ({
    payment_type: 'cryptocurrency'
  });
}

function getViewsContext(data, store) {
  const REACTIVE_FIELDS = ['REDIRECT_URL'];
  const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);

  $context.$subscribe('REDIRECT_URL', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue && oldValue === currentValue) && currentValue instanceof URL) {
        RedirectView && RedirectView.activate.call($context);
      }
    }, 0);
  });

  return withProperties($context, {
    INIT_VIEW: callback => {
      InitView && InitView.activate(callback);
    }
  });
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  getChargeData,
  getViewsContext
}
